export class VERSION_CONFIG {
  static readonly CURRENT_VIESION = "1.0.28";
  static readonly CURRENT_SMALL_VIESION = "i051";
  // 機能アップデートのお知らせを表示するかのフラグ
  static readonly SHOW_VERSIONUP_INTRODUCTION = true;
}



// WEBPACK FOOTER //
// ./src/configs/version.config.ts